import { AdverseEventDetailScreen, QcDetailScreen } from '../features/console';
import { useLocation } from 'react-router-dom';

export function QCDetailPage() {
  const location = useLocation();
  return location.pathname.includes('/adverse-events/') ? (
    <AdverseEventDetailScreen />
  ) : (
    <QcDetailScreen />
  );
}
